import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canManageHeating } from "../utils/userUtils";

const HeatingRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return canManageHeating(user) ? children : <Navigate to="/" replace />;
};

export default HeatingRoute;

